import React from 'react';
import { sendExportAllPeopleRequest } from 'misc/async_reports_helper';
import { Export } from 'ui/Icon/Streamline';
import ActionButton from '../shared/ActionButton';

const ExportAllPeopleButton = ({
  activeGroupId,
  hasUnificationFeatureFlag,
}) => {
  return (
    <div className="d-f ai-c">
      {hasUnificationFeatureFlag && (
        <div
          className="LearnContentGroup-action u-linkBtn h-cr-p d-f ai-c"
          role="button"
          onClick={() => sendExportAllPeopleRequest(activeGroupId)}
          onKeyDown={e =>
            e.key === 'Enter' && sendExportAllPeopleRequest(activeGroupId)
          }
          tabIndex={0}
        >
          <Export className="mr-4" />
          <span className="fz-14 fw-600 lh-16">
            {activeGroupId
              ? t('groups.show.export')
              : t('groups.show.export_all')}
          </span>
        </div>
      )}
      {!hasUnificationFeatureFlag && (
        <ActionButton
          tabIndex="0"
          label={
            activeGroupId
              ? t('groups.show.export_selected_group')
              : t('groups.show.export_all_people')
          }
          handleClick={e => sendExportAllPeopleRequest(activeGroupId)}
          iconName="download"
          customButtonStyles="u-linkBtn c-p ff-ss"
        />
      )}
    </div>
  );
};

export default ExportAllPeopleButton;
